import { render, staticRenderFns } from "./MultipleCollection.vue?vue&type=template&id=72451c12&"
import script from "./MultipleCollection.vue?vue&type=script&lang=js&"
export * from "./MultipleCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports